module.exports = __webpack_public_path__ + "/images/ico-color-mobile-cart.55b6825.svg";